import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Mobile, BlueChatbiz } from '../../../_Variable/var';

const Wrapper = styled.div`
	&.h2Default {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 1.5rem;
		line-height: 140%;
		color: #4f4f4f;
		@media only screen and (max-width: ${Mobile}) {
			font-size: 1.125rem;
		}
		span {
			color: ${BlueChatbiz};
		}
	}
`;

const H2 = ({ children, className }) => {
	return <Wrapper className={className || 'h2Default'}>{children}</Wrapper>;
};

H2.defaultProps = {
	className: '',
};

H2.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default H2;
